import script from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./NuovaRilevazione.vue?vue&type=style&index=0&id=16c84e4e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c84e4e"]])

export default __exports__